module.exports = __webpack_public_path__ + "img/ic-6.d82a2e0.svg";